'use client';

import H2 from '@/components/typography/h2';
import P from '@/components/typography/p';

interface CaseCreditProps {
    credits: {
        rol: string;
        naam: string;
        id?: string | null;
    }[];
}

export default function CaseCredit({ credits }: CaseCreditProps) {
    return (
        <div className="flex flex-col items-center pb-10">
            <div className="bg-lightblue flex w-auto max-w-[90%] rotate-2 flex-col rounded-lg lg:w-[827px]">
                <div className="w-full border-b border-black">
                    <div className="flex justify-center px-5 py-7 pb-3 lg:px-16 lg:pt-10 lg:pb-5">
                        <H2 variant="italic" className="uppercase">
                            CREDITS
                        </H2>
                    </div>
                </div>
                <div className="flex flex-col justify-between gap-3 px-5 pt-7 pb-5 lg:px-12 lg:pt-10 lg:pb-10">
                    {credits.map((credit, index) => (
                        <div
                            key={index}
                            className="relative flex items-end justify-between text-sm"
                        >
                            <P
                                variant="credit"
                                className="w-min pr-1 uppercase sm:w-auto lg:max-w-1/2"
                            >
                                {credit.rol}
                            </P>
                            <div className="border-primary mt-auto mb-1 min-w-[1rem] flex-1 border-b-[2.5px] border-dotted" />
                            <P
                                variant="credit"
                                className="w-min overflow-hidden pl-2 text-ellipsis whitespace-nowrap sm:w-auto"
                            >
                                {credit.naam}
                            </P>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
